import React from 'react';
import PropTypes from 'prop-types';
import {merge as _merge} from 'lodash';

import {createForm} from '@utils/forms';
import {mapPropertyLicencesForDropdown} from '@utils/propertyLicence';

import {MatchesSimpleTable} from '../components/EventsMultiple/MatchesSimpleTable';
import EventsMultipleCreationModel from '../forms/EventsMultipleCreationModel';
import EventsMultipleCreationForm from '../forms/EventsMultipleCreationForm';

export const EventsMultipleCreation = ({
    data: {
        eventStatuses,
        matches,
        propertyLicencesForMultipleMatchesDropdown,
        clipProviders,
    },
    eventContentTypes,
    matchesIds,
    modelObjectExtension,
    queryForRefetch,
}) => {
    const propertyLicenceForDropdown = mapPropertyLicencesForDropdown(propertyLicencesForMultipleMatchesDropdown);
    const Form = createForm(
        () => (_merge(EventsMultipleCreationModel(), modelObjectExtension)),
        EventsMultipleCreationForm,
        {
            propertyLicencesOptions: propertyLicenceForDropdown,
            propertyLicences: propertyLicencesForMultipleMatchesDropdown,
            eventStatuses: eventStatuses,
            matches: matchesIds,
            clipProviders: clipProviders,
            eventContentTypes: eventContentTypes,
            queryForRefetch: queryForRefetch,
        }
    );

    return <>
        <div className='ui form'>
            <MatchesSimpleTable
                matches={matches}
            />
        </div>
        <div>
            <Form />
        </div>
    </>;
};

EventsMultipleCreation.propTypes = {
    data: PropTypes.object,
    eventContentTypes: PropTypes.array,
    matchesIds: PropTypes.array,
    modelObjectExtension: PropTypes.object,
    queryForRefetch: PropTypes.string,
};

EventsMultipleCreation.defaultProps = {
    data: {},
    eventContentTypes: [],
    matchesIds: [],
    modelObjectExtension: {},
    queryForRefetch: '',
};
